import React, { useState, useEffect } from 'react';
import axiosInstance from '../utils/axiosInstance';
import { API_URL } from '../utils/runtimeConfig';

const apiUrl = API_URL;

const ComparisonHeader = ({
  comparisonType,
  setComparisonType,
  setItem1,
  setItem2,
  hideComparisonTypeDropdown = false,
  item1Label = 'Select Item 1',
  item2Label = 'Select Item 2',
  selectPlaceholder = 'Select'
}) => {
  const axios = axiosInstance;
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        let response;
        const effectiveType = hideComparisonTypeDropdown ? 'nation' : comparisonType;
        if (effectiveType === 'nation') {
          response = await axios.get(`${apiUrl}/nations`);
        } else if (effectiveType === 'alliance') {
          response = await axios.get(`${apiUrl}/alliances`);
        } else if (effectiveType === 'commander') {
          response = await axios.get(`${apiUrl}/commanders`);
        }
        setOptions(response?.data || []);
      } catch (error) {
        console.error('Error fetching options:', error);
      }
    };

    fetchOptions();
  }, [comparisonType, hideComparisonTypeDropdown, axios]);

  return (
    <div className="comparison-header">
      {!hideComparisonTypeDropdown && (
        <div>
          <label>Select Comparison Type:</label>
          <select
            value={comparisonType}
            onChange={(e) => setComparisonType(e.target.value)}
          >
            <option value="nation">Nation</option>
            <option value="alliance">Alliance</option>
            <option value="commander">Commander</option>
          </select>
        </div>
      )}

      <div>
        <label>{item1Label}:</label>
        <select onChange={(e) => setItem1(e.target.value)}>
          <option value="">{selectPlaceholder}</option>
          {options.map((option) => (
            <option key={option._id} value={option._id}>
              {option.number || option.acronym || option.name}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label>{item2Label}:</label>
        <select onChange={(e) => setItem2(e.target.value)}>
          <option value="">{selectPlaceholder}</option>
          {options.map((option) => (
            <option key={option._id} value={option._id}>
              {option.number || option.acronym || option.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ComparisonHeader;
